/** @format */

import React, { useState, useEffect } from "react"; // Import useEffect
import { Link } from "react-scroll";
import ScrollReveal from "scrollreveal"; // Import ScrollReveal
import Title from "./mini-components/Title";
// Images
import img1 from "../assets/screenshot/Accueil - Jour.png";
import img2 from "../assets/screenshot/Accueil - Vue semaine.png";
import img3 from "../assets/screenshot/Ajout Rendez-vous.png";
import img4 from "../assets/screenshot/Recherche par Maps.png";

export default function Galeries() {
  const images = [
    {
      src: img1,
      title: "Accueil",
      description: "Vue par jour",
      alt: "Accueil - Vue par jour",
    },
    {
      src: img2,
      title: "Accueil",
      description: "Vue par semaine",
      alt: "Accueil - Vue par semaine",
    },
    {
      src: img3,
      title: "Ajout de rendez-vous",
      description: "Description du rendez-vous",
      alt: "Ajout de rendez-vous",
    },
    {
      src: img4,
      title: "Ajout de rendez-vous",
      description: "Visualisation sur Google Maps",
      alt: "Recherche par Maps",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    // Initialize ScrollReveal
    const sr = ScrollReveal({
      origin: "bottom", // Change this based on your preferred direction
      distance: "30px",
      duration: 500,
      delay: 100,
      easing: "ease-in-out",
    });

    // Reveal elements
    sr.reveal(".reveal", { interval: 100 }); // Applies reveal to all elements with class 'reveal'
  }, []);

  return (
    <div className="relative">
      <section id="galeries" className="w-11/12 mx-auto pt-4">
        {/* Titre de la section */}
        <Title title="Galerie" textplacement="right" />

        {/* Carousel Wrapper */}
        <div
          className="relative mt-8 w-full overflow-hidden rounded-lg"
          style={{ maxWidth: "800px", height: "560px", margin: "0 auto" }}
        >
          {/* Afficher l'image active */}
          <div className="relative w-full h-full">
            <img
              src={images[currentIndex].src}
              alt={images[currentIndex].alt}
              className="absolute block max-w-full h-auto -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 transition-opacity duration-700"
            />
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-black bg-opacity-50 text-white text-center">
              <h3 className="text-lg font-semibold reveal">
                {images[currentIndex].title}
              </h3>
              <p className="text-sm reveal">
                {images[currentIndex].description}
              </p>
            </div>
          </div>
        </div>

        {/* Carousel controls */}
        <div className="flex justify-center items-center pt-4">
          <button
            type="button"
            className="flex justify-center items-center me-4 h-full cursor-pointer group focus:outline-none"
            onClick={prevImage}
          >
            <span className="text-gray-400 hover:text-gray-900 group-focus:text-gray-900">
              <svg
                className="rtl:rotate-180 w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 5H1m0 0 4 4M1 5l4-4"
                />
              </svg>
              <span className="sr-only">Previous</span>
            </span>
          </button>
          <button
            type="button"
            className="flex justify-center items-center h-full cursor-pointer group focus:outline-none"
            onClick={nextImage}
          >
            <span className="text-gray-400 hover:text-gray-900 group-focus:text-gray-900">
              <svg
                className="rtl:rotate-180 w-5 h-5"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 10"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M1 5h12m0 0L9 1m4 4L9 9"
                />
              </svg>
              <span className="sr-only">Next</span>
            </span>
          </button>
        </div>

        <div className="flex justify-center items-center flex-col mt-16">
          <Link
            to="telechargements"
            smooth={true}
            duration={500}
            className="cursor-pointer bg-white text-green-900 px-6 py-2 sm:px-8 sm:py-3 rounded-lg hover:bg-green-900 hover:text-white transition duration-150 ease-in-out reveal" // Added reveal class here
          >
            Essayer Plan&Drive
          </Link>
        </div>
      </section>
    </div>
  );
}
